var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopySign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66602 6.16675V4.50008C6.66602 2.65913 8.1584 1.16675 9.99935 1.16675L14.9993 1.16675C16.8403 1.16675 18.3327 2.65913 18.3327 4.50008V9.50008C18.3327 11.341 16.8403 12.8334 14.9993 12.8334H13.3327M6.66602 6.16675H4.99935C3.1584 6.16675 1.66602 7.65913 1.66602 9.50008V14.5001C1.66602 16.341 3.1584 17.8334 4.99935 17.8334H9.99935C11.8403 17.8334 13.3327 16.341 13.3327 14.5001V12.8334M6.66602 6.16675H9.99935C11.8403 6.16675 13.3327 7.65913 13.3327 9.50008V12.8334",
    stroke: "#28303F",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopySign);
export default __webpack_public_path__ + "static/media/CopySign.86370387a62c62652e4d475b6d74fe5b.svg";
export { ForwardRef as ReactComponent };